module.exports = __webpack_public_path__ + "img/9.3899a655.jpg";